import sortBy from 'lodash/sortBy'
import type {ParserT} from '@freckle/parser'
import {array, record, string} from '@freckle/parser'
import type {
  DehydratedDomain,
  RlDomainT
} from '@freckle/educator-entities/ts/common/models/rl-domain'
import type {
  DehydratedStandard,
  RlStandardT
} from '@freckle/educator-entities/ts/common/models/rl-standard'

export type DehydratedRlDomainStandard = {
  domain: DehydratedDomain
  standards: Array<DehydratedStandard>
}

export type RlDomainStandardT = {
  domain: RlDomainT
  standards: Array<RlStandardT>
}

export const parseDehydrated: ParserT<DehydratedRlDomainStandard> = record({
  domain: record({id: string()}),
  standards: array(record({id: string()}))
})

export function toKey(domainStandard: DehydratedRlDomainStandard): string {
  const {domain, standards} = domainStandard
  const domainKey = domain.id
  const standardIds = sortBy(standards.map(standard => standard.id))
  return standardIds.length === 0 ? domainKey : `${domainKey}-${standardIds.join('-')}`
}
